import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ConfirmProvider } from "@/lib/confirm";
import { Toaster } from "@/components/ui/sonner";
import { Spinner } from "@/components/ui-kit";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ClientsList from "@/pages/ClientsList";
import ClientForm from "@/pages/ClientForm";
import ClientDetail from "@/pages/ClientDetail";
import ProjectsList from "@/pages/ProjectsList";
import ProjectForm from "@/pages/ProjectForm";
import ProjectDetail from "@/pages/ProjectDetail";
import QuotesList from "@/pages/QuotesList";
import QuoteForm from "@/pages/QuoteForm";
import QuoteDetail from "@/pages/QuoteDetail";
import Invoiced from "@/pages/Invoiced";
import SuppliersList from "@/pages/SuppliersList";
import SupplierForm from "@/pages/SupplierForm";
import ProofPage from "@/pages/ProofPage";
import QuotePublicPage from "@/pages/QuotePublicPage";
import Proofing from "@/pages/Proofing";
import Admin from "@/pages/Admin";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center"><Spinner className="w-6 h-6" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center"><Spinner className="w-6 h-6" /></div>;
  }
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/proof/:token" element={<ProofPage />} />
            <Route path="/proof/:token/:slug" element={<ProofPage />} />
            <Route path="/quote/:token" element={<QuotePublicPage />} />
            <Route path="/quote/:token/:slug" element={<QuotePublicPage />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/clients" element={<Protected><ClientsList /></Protected>} />
            <Route path="/clients/new" element={<Protected><ClientForm mode="new" /></Protected>} />
            <Route path="/clients/:id" element={<Protected><ClientDetail /></Protected>} />
            <Route path="/clients/:id/edit" element={<Protected><ClientForm mode="edit" /></Protected>} />
            <Route path="/projects" element={<Protected><ProjectsList /></Protected>} />
            <Route path="/projects/new" element={<Protected><ProjectForm mode="new" /></Protected>} />
            <Route path="/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
            <Route path="/projects/:id/edit" element={<Protected><ProjectForm mode="edit" /></Protected>} />
            <Route path="/quotes" element={<Protected><QuotesList /></Protected>} />
            <Route path="/quotes/new" element={<Protected><QuoteForm mode="new" /></Protected>} />
            <Route path="/quotes/:id" element={<Protected><QuoteDetail /></Protected>} />
            <Route path="/quotes/:id/edit" element={<Protected><QuoteForm mode="edit" /></Protected>} />
            <Route path="/proofing" element={<Protected><Proofing /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/invoiced" element={<Protected><Invoiced /></Protected>} />
            <Route path="/suppliers" element={<Protected><SuppliersList /></Protected>} />
            <Route path="/suppliers/new" element={<Protected><SupplierForm mode="new" /></Protected>} />
            <Route path="/suppliers/:id/edit" element={<Protected><SupplierForm mode="edit" /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        </ConfirmProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
